import { computed, defineComponent, onMounted, reactive } from 'vue';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { InfoGraphicAction, InfoGraphicGetter } from '@/store/infoGraphic/infoGraphic.module';
import { InfoGraphic } from '@/store/infoGraphic/infoGraphic.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import PaginateComponent from '@/components/paginate/Paginate.vue';

export default defineComponent({
  name: 'InfoGraphicListComponent',
  components: {
    LoadingComponent,
    PaginateComponent
  },
  emits: [
    'edit'
  ],
  setup: (_, context) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const infoGraphics = computed<InfoGraphic[]>(() => store.getters[InfoGraphicGetter.ALL]);
    const search = computed(() => infoGraphics.value.filter((infoGraphic) => toSearch(infoGraphic)));
    const display = computed(() => search.value.filter((_, index) => toDisplay(index)));
    const isLoading = computed(() => store.getters[InfoGraphicGetter.STATUS] === 'init' || store.getters[InfoGraphicGetter.STATUS] === 'loading');

    onMounted(() => {
      store.dispatch(InfoGraphicAction.FETCH);
    });

    const filter = reactive({
      keyword: '',
      amount: computed(() => search.value.length),
      total: computed(() => infoGraphics.value.length)
    });

    const page = reactive({
      size: 6,
      current: 1
    });

    const toSearch = (infoGraphic: InfoGraphic): InfoGraphic | boolean => {
      return (filter.keyword)
        ? infoGraphic.title.toLowerCase().includes(filter.keyword.toLowerCase())
          ? infoGraphic
          : false
        : true;
    };

    const toDisplay = (index: number) => {
      const start = (page.current - 1) * page.size;
      const end = start + page.size;
      return index >= start && index < end;
    };

    const editClick = (id: number) => {
      context.emit('edit', id);
    };

    const toggleClick = (id: number) => {
      const infoGraphic = infoGraphics.value.find(m => m.id == id);
      store.dispatch(InfoGraphicAction.PINNING, {
        id: id,
        pined: !infoGraphic?.pined,
      });
    };

    const selectedPage = (pageNumber: number) => {
      page.current = pageNumber;
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    return {
      isLoading,
      display,
      filter,
      page,
      editClick,
      selectedPage,
      toggleClick,
      thaiDate,
    };
  },
});
